import i18next from 'i18next';
import React from 'react';
import theme from '@theme';

import {
  Dropdown,
  DropdownRowMultipleLines,
  INPUT_WIDTH,
} from '@commons/utils/styledLibraryComponents';
import { getIngredientUnitName } from '@commons/utils/units';
import Text, { CUSTOM_STYLE_FOR_DROPDOWN_TEXT, ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  BackgroundImage,
  DropdownItemContainer,
  ImageContainer,
  SubtitleContainer,
} from '@commons/PaginatedSupplierProductsDropdown/styledComponents';

import { CompositionDropdownContainer } from '../../styledComponents';

const DEFAULT_INGREDIENT_PICTURE = '/images/inpulse/ingredient-photo-placeholder.svg';

const IngredientDropdown = (props) => {
  const {
    handleEntityChange,
    ingredients,
    isReadOnly,
    composition,
    isKitchenProduct,
    isLoading,
    handleIngredientCreation,
    width = '340px',
    errorMessage = null,
  } = props;

  const renderedIngredients = ingredients.map((ingredient) => ({
    ...ingredient,
    tags: [getIngredientUnitName(ingredient.unit)],
    value: ingredient.name,
    renderValue: () => (
      <DropdownItemContainer>
        <ImageContainer>
          <BackgroundImage src={ingredient.img || DEFAULT_INGREDIENT_PICTURE} />
        </ImageContainer>
        <DropdownRowMultipleLines>
          <Text
            font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
            style={{ ...CUSTOM_STYLE_FOR_DROPDOWN_TEXT, paddingRight: '8px', width: 'auto' }}
          >
            {ingredient.name}
          </Text>
          <SubtitleContainer>
            <Text
              color={theme.colors.greys.dark}
              font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}
              style={{ ...CUSTOM_STYLE_FOR_DROPDOWN_TEXT, paddingRight: '8px', width: 'auto' }}
            >
              {ingredient.category}
            </Text>
          </SubtitleContainer>
        </DropdownRowMultipleLines>
      </DropdownItemContainer>
    ),
  }));

  return (
    <CompositionDropdownContainer>
      <Dropdown
        button={
          isKitchenProduct
            ? {
                id: 1,
                text: i18next.t('ADMIN.INGREDIENTS.CREATE'),
                handleClick: handleIngredientCreation,
                iconSrc: '/images/inpulse/add-black-small.svg',
              }
            : null
        }
        customStyle={{ height: 'auto', width }}
        isDisabled={isReadOnly || isLoading}
        isErrorState={!!errorMessage}
        items={renderedIngredients}
        label={i18next.t('GENERAL.INGREDIENT')}
        labelStyle={{ font: theme.fonts.textSmall }}
        placeholder={i18next.t('GENERAL.SEARCH')}
        selectedItem={composition}
        tooltipText={
          isKitchenProduct ? '' : i18next.t('ADMIN.PRODUCTS.COMPOSITION_TOOLTIP_INGREDIENT')
        }
        isRequired
        largeDropdownList
        onSelectionChange={handleEntityChange}
      />
      {errorMessage && (
        <Text
          color={ENUM_COLORS.INFO_RED}
          font={ENUM_FONTS.TEXT_SMALL_HEIGHT_14_WEIGHT_600}
          style={{ width: INPUT_WIDTH.LARGE }}
        >
          {errorMessage}
        </Text>
      )}
    </CompositionDropdownContainer>
  );
};

export default IngredientDropdown;
